import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { DownloadHub } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useDownloadHubQuery = () => {
  const branchId = useBranchId();

  const query = useQuery<DownloadHub[]>({
    queryKey: ["download-hub", branchId],
    queryFn: () => get2(`internal/secure/pos/v1/download/hub`),
  });

  return query;
};

export default useDownloadHubQuery;
